$('.slide_img').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    autoplay: true,
    cssEase: 'linear'
});

document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('sliderVideo');

    // Устанавливаем скорость воспроизведения (0.5 = 50% от нормальной скорости)
    video.playbackRate = 0.5;

    video.play().catch(function(error) {
        console.log("Автовоспроизведение заблокировано:", error);
        // Показываем кнопку для ручного запуска видео
        const playButton = document.createElement('button');
        playButton.textContent = 'Включить видео';
        playButton.style.position = 'fixed';
        playButton.style.bottom = '20px';
        playButton.style.right = '20px';
        playButton.style.zIndex = '1000';
        playButton.style.padding = '10px 20px';
        playButton.style.background = '#FE4856';
        playButton.style.color = 'white';
        playButton.style.border = 'none';
        playButton.style.borderRadius = '5px';
        playButton.style.cursor = 'pointer';

        playButton.addEventListener('click', function() {
            video.play();
            playButton.remove();
        });

        document.body.appendChild(playButton);
    });
});